import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';

import useAddPage from 'hooks/useAddPage';
const MembermasterAddPage = (props) => {
		const app = useApp();
	const utils = useUtils();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		memberid: yup.string().required().label($t('memberid')),
		membername: yup.string().required().label($t('membername')),
		groupid: yup.string().required().label($t('groupid')),
		father_name: yup.string().required().label($t('fatherName')),
		husband_name: yup.string().nullable().label($t('husbandName')),
		joiningdate: yup.string().required().label($t('joiningdate')),
		dob: yup.string().required().label($t('dob')),
		age: yup.number().nullable().label($t('age')),
		gender: yup.string().required().label($t('gender')),
		statename: yup.string().required().label($t('statename')),
		marital_status: yup.string().required().label($t('maritalStatus')),
		addressline1: yup.string().required().label($t('addressline1')),
		addressline2: yup.string().nullable().label($t('addressline2')),
		branchcode: yup.string().required().label($t('branchcode')),
		district: yup.string().required().label($t('district')),
		policestation: yup.string().required().label($t('policestation')),
		pincode: yup.string().required().label($t('pincode')),
		id1: yup.string().required().label($t('id1')),
		idcardnumber: yup.string().required().label($t('idCardNumber')),
		id2: yup.string().nullable().label($t('id2')),
		idcardnumber_ex: yup.string().nullable().label($t('idcardnumberEx')),
		pancard: yup.string().nullable().label($t('pancard')),
		religion: yup.string().required().label($t('religion')),
		caste: yup.string().required().label($t('caste')),
		occupation: yup.string().required().label($t('occupation')),
		qualification: yup.string().required().label($t('qualification')),
		mobileno: yup.string().required().label($t('mobileno')),
		mobileno_ex: yup.string().nullable().label($t('mobilenoEx')),
		email: yup.string().email().required().label($t('email')),
		nomineename: yup.string().nullable().label($t('nomineename')),
		nominee_relation: yup.string().nullable().label($t('nomineeRelation')),
		nominee_age: yup.number().nullable().label($t('nomineeAge')),
		mother_name: yup.string().nullable().label($t('motherName')),
		area: yup.string().required().label($t('area')),
		subarea: yup.string().required().label($t('subarea')),
		bankname: yup.string().nullable().label($t('bankname')),
		accountno: yup.string().nullable().label($t('accountno')),
		ifsec: yup.string().nullable().label($t('ifsec')),
		resk_evaluated: yup.array().nullable().label($t('reskEvaluated')),
		photo_upload: yup.string().nullable().label($t('photoUpload')),
		id_upload: yup.string().nullable().label($t('idUpload')),
		idcardpicture: yup.string().nullable().label($t('idcardpicture')),
		sign_upload: yup.string().nullable().label($t('signUpload')),
		house_upload: yup.string().nullable().label($t('houseUpload')),
		map_upload: yup.string().nullable().label($t('mapUpload'))
	});
	
	//form default values
	const formDefaultValues = {
		memberid: utils.randomNum(6), 
		membername: '', 
		groupid: '', 
		father_name: '', 
		husband_name: '', 
		joiningdate: "(getdate())", 
		dob: new Date(), 
		age: '', 
		gender: '', 
		statename: '', 
		marital_status: '', 
		addressline1: '', 
		addressline2: '', 
		branchcode: '', 
		district: '', 
		policestation: '', 
		pincode: '', 
		id1: '', 
		idcardnumber: '', 
		id2: '', 
		idcardnumber_ex: '', 
		pancard: '', 
		religion: '', 
		caste: '', 
		occupation: '', 
		qualification: '', 
		mobileno: '', 
		mobileno_ex: '', 
		email: '', 
		nomineename: '', 
		nominee_relation: '', 
		nominee_age: '', 
		mother_name: '', 
		area: '', 
		subarea: '', 
		bankname: '', 
		accountno: '', 
		ifsec: '', 
		resk_evaluated: [], 
		photo_upload: '', 
		id_upload: '', 
		idcardpicture: '', 
		sign_upload: '', 
		house_upload: '', 
		map_upload: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/membermaster/add`);
		}
	}
	
	//auto fill other inputs on gender change
	async function genderAutoFill(e, formik, index) {
		formik.handleChange(e);
const dob = formik.values.dob;
if (dob) {
  const today = new Date();
  const birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  // Adjust if birthday hasn't occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  formik.setFieldValue('age', age);
}
	};
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="MembermasterAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewMember')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('memberid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="memberid"  onChange={formik.handleChange}  value={formik.values.memberid}   label={$t('memberid')} type="text" placeholder={$t('enterMemberid')}     disabled   className={inputClassName(formik?.errors?.memberid)} />
                                                <ErrorMessage name="memberid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('membername')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="membername"  onChange={formik.handleChange}  value={formik.values.membername}   label={$t('membername')} type="text" placeholder={$t('enterMembername')}        className={inputClassName(formik?.errors?.membername)} />
                                                <ErrorMessage name="membername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('groupid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/groupid_option_list_3"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="groupid"     optionLabel="label" optionValue="value" value={formik.values.groupid} onChange={formik.handleChange} options={response} label={$t('groupid')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.groupid)}   />
                                                    <ErrorMessage name="groupid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fatherName')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="father_name"  onChange={formik.handleChange}  value={formik.values.father_name}   label={$t('fatherName')} type="text" placeholder={$t('enterFatherName')}        className={inputClassName(formik?.errors?.father_name)} />
                                                <ErrorMessage name="father_name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('husbandName')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="husband_name"  onChange={formik.handleChange}  value={formik.values.husband_name}   label={$t('husbandName')} type="text" placeholder={$t('enterHusbandName')}        className={inputClassName(formik?.errors?.husband_name)} />
                                                <ErrorMessage name="husband_name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('joiningdate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="joiningdate" showButtonBar className={inputClassName(formik?.errors?.joiningdate)} dateFormat="yy-mm-dd" value={formik.values.joiningdate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="joiningdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dob')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="dob" showButtonBar className={inputClassName(formik?.errors?.dob)} dateFormat="yy-mm-dd" value={formik.values.dob} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="dob" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('age')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="age"  onChange={formik.handleChange}  value={formik.values.age}   label={$t('age')} type="number" placeholder={$t('enterAge')}  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.age)} />
                                                <ErrorMessage name="age" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('gender')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.gender.map((option) => {
                                                return (
                                                <div key={option.value} className="field-radiobutton">
                                                    <RadioButton inputId={option.value} name="gender" value={option.value} onChange={(e)=>genderAutoFill(e, formik)}  checked={formik.values.gender === option.value} className={inputClassName(formik?.errors?.gender, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="gender" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('statename')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/statename_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <span className="p-input-icon-left w-full">
                                                    <i className="pi pi-folder"></i>
                                                    <Dropdown  name="statename"     optionLabel="label" optionValue="value" value={formik.values.statename} onChange={formik.handleChange} options={response} label={$t('statename')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.statename)}   />
                                                    </span>
                                                    <ErrorMessage name="statename" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maritalStatus')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/maritalstatus_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="marital_status"     optionLabel="label" optionValue="value" value={formik.values.marital_status} onChange={formik.handleChange} options={response} label={$t('maritalStatus')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.marital_status)}   />
                                                    <ErrorMessage name="marital_status" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addressline1')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addressline1"  onChange={formik.handleChange}  value={formik.values.addressline1}   label={$t('addressline1')} type="text" placeholder={$t('enterAddressline1')}        className={inputClassName(formik?.errors?.addressline1)} />
                                                <ErrorMessage name="addressline1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('addressline2')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="addressline2"  onChange={formik.handleChange}  value={formik.values.addressline2}   label={$t('addressline2')} type="text" placeholder={$t('enterAddressline2')}        className={inputClassName(formik?.errors?.addressline2)} />
                                                <ErrorMessage name="addressline2" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('branchcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/branchcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={formik.handleChange} options={response} label={$t('branchcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                    <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('district')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/district_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <span className="p-input-icon-left w-full">
                                                    <i className="pi pi-folder"></i>
                                                    <Dropdown  name="district"     optionLabel="label" optionValue="value" value={formik.values.district} onChange={formik.handleChange} options={response} label={$t('district')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.district)}   />
                                                    </span>
                                                    <ErrorMessage name="district" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('policestation')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/policestation_option_list_2"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="policestation"     optionLabel="label" optionValue="value" value={formik.values.policestation} onChange={formik.handleChange} options={response} label={$t('policestation')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.policestation)}   />
                                                    <ErrorMessage name="policestation" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pincode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pincode"  onChange={formik.handleChange}  value={formik.values.pincode}   label={$t('pincode')} type="text" placeholder={$t('enterPincode')}        className={inputClassName(formik?.errors?.pincode)} />
                                                <ErrorMessage name="pincode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('id1')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="id1"     optionLabel="label" optionValue="value" value={formik.values.id1} onChange={formik.handleChange} options={app.menus.id1} label={$t('id1')}  placeholder={$t('selectIdCard')}  className={inputClassName(formik?.errors?.id1)}   />
                                                <ErrorMessage name="id1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idCardNumber')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcardnumber"  onChange={formik.handleChange}  value={formik.values.idcardnumber}   label={$t('idCardNumber')} type="text" placeholder={$t('enterIdCardNumber')}        className={inputClassName(formik?.errors?.idcardnumber)} />
                                                <ErrorMessage name="idcardnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('id2')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="id2"     optionLabel="label" optionValue="value" value={formik.values.id2} onChange={formik.handleChange} options={app.menus.id2} label={$t('id2')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.id2)}   />
                                                <ErrorMessage name="id2" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcardnumberEx')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcardnumber_ex"  onChange={formik.handleChange}  value={formik.values.idcardnumber_ex}   label={$t('idcardnumberEx')} type="text" placeholder={$t('enterOtherCardNumber')}        className={inputClassName(formik?.errors?.idcardnumber_ex)} />
                                                <ErrorMessage name="idcardnumber_ex" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('pancard')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="pancard"  onChange={formik.handleChange}  value={formik.values.pancard}   label={$t('pancard')} type="text" placeholder={$t('enterPancard')}        className={inputClassName(formik?.errors?.pancard)} />
                                                <ErrorMessage name="pancard" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('religion')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/religion_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="religion"     optionLabel="label" optionValue="value" value={formik.values.religion} onChange={formik.handleChange} options={response} label={$t('religion')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.religion)}   />
                                                    <ErrorMessage name="religion" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('caste')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/caste_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="caste"     optionLabel="label" optionValue="value" value={formik.values.caste} onChange={formik.handleChange} options={response} label={$t('caste')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.caste)}   />
                                                    <ErrorMessage name="caste" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('occupation')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/occupation_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="occupation"     optionLabel="label" optionValue="value" value={formik.values.occupation} onChange={formik.handleChange} options={response} label={$t('occupation')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.occupation)}   />
                                                    <ErrorMessage name="occupation" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('qualification')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/qualification_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="qualification"     optionLabel="label" optionValue="value" value={formik.values.qualification} onChange={formik.handleChange} options={response} label={$t('qualification')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.qualification)}   />
                                                    <ErrorMessage name="qualification" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobileno')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobileno"  onChange={formik.handleChange}  value={formik.values.mobileno}   label={$t('mobileno')} type="text" placeholder={$t('enterMobileno')}        className={inputClassName(formik?.errors?.mobileno)} />
                                                <ErrorMessage name="mobileno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobilenoEx')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobileno_ex"  onChange={formik.handleChange}  value={formik.values.mobileno_ex}   label={$t('mobilenoEx')} type="text" placeholder={$t('enterMobilenoEx')}        className={inputClassName(formik?.errors?.mobileno_ex)} />
                                                <ErrorMessage name="mobileno_ex" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('email')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="email"  onChange={formik.handleChange}  value={formik.values.email}   label={$t('email')} type="email" placeholder={$t('enterEmail')}        className={inputClassName(formik?.errors?.email)} />
                                                <ErrorMessage name="email" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nomineename')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nomineename"  onChange={formik.handleChange}  value={formik.values.nomineename}   label={$t('nomineename')} type="text" placeholder={$t('enterNomineename')}        className={inputClassName(formik?.errors?.nomineename)} />
                                                <ErrorMessage name="nomineename" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nomineeRelation')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nominee_relation"  onChange={formik.handleChange}  value={formik.values.nominee_relation}   label={$t('nomineeRelation')} type="text" placeholder={$t('enterNomineeRelation')}        className={inputClassName(formik?.errors?.nominee_relation)} />
                                                <ErrorMessage name="nominee_relation" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('nomineeAge')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="nominee_age"  onChange={formik.handleChange}  value={formik.values.nominee_age}   label={$t('nomineeAge')} type="number" placeholder={$t('enterNomineeAge')}  min={0}  step="any"    className={inputClassName(formik?.errors?.nominee_age)} />
                                                <ErrorMessage name="nominee_age" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('motherName')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mother_name"  onChange={formik.handleChange}  value={formik.values.mother_name}   label={$t('motherName')} type="text" placeholder={$t('enterMotherName')}        className={inputClassName(formik?.errors?.mother_name)} />
                                                <ErrorMessage name="mother_name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('area')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/area_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <span className="p-input-icon-left w-full">
                                                    <i className="pi pi-folder"></i>
                                                    <Dropdown  name="area"     optionLabel="label" optionValue="value" value={formik.values.area} onChange={formik.handleChange} options={response} label={$t('area')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.area)}   />
                                                    </span>
                                                    <ErrorMessage name="area" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('subarea')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/subarea_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <span className="p-input-icon-left w-full">
                                                    <i className="pi pi-folder"></i>
                                                    <Dropdown  name="subarea"     optionLabel="label" optionValue="value" value={formik.values.subarea} onChange={formik.handleChange} options={response} label={$t('subarea')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.subarea)}   />
                                                    </span>
                                                    <ErrorMessage name="subarea" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bankname"  onChange={formik.handleChange}  value={formik.values.bankname}   label={$t('bankname')} type="text" placeholder={$t('enterBankname')}        className={inputClassName(formik?.errors?.bankname)} />
                                                <ErrorMessage name="bankname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountno')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountno"  onChange={formik.handleChange}  value={formik.values.accountno}   label={$t('accountno')} type="text" placeholder={$t('enterAccountno')}        className={inputClassName(formik?.errors?.accountno)} />
                                                <ErrorMessage name="accountno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('ifsec')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ifsec"  onChange={formik.handleChange}  value={formik.values.ifsec}   label={$t('ifsec')} type="text" placeholder={$t('enterIfsec')}        className={inputClassName(formik?.errors?.ifsec)} />
                                                <ErrorMessage name="ifsec" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('reskEvaluated')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.reskEvaluated.map((option) => {
                                                return (
                                                <div key={option.value} className="field-checkbox">
                                                    <Checkbox inputId={option.value} name="resk_evaluated" value={option.value} onChange={formik.handleChange} checked={formik.values.resk_evaluated.includes(option.value)} className={inputClassName(formik?.errors?.resk_evaluated, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="resk_evaluated" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('photoUpload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.photo_upload)}>
                                                    <Uploader name="photo_upload" showUploadedFiles value={formik.values.photo_upload} uploadPath="fileuploader/upload/photo_upload" onChange={(paths) => formik.setFieldValue('photo_upload', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="photo_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idUpload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.id_upload)}>
                                                    <Uploader name="id_upload" showUploadedFiles value={formik.values.id_upload} uploadPath="fileuploader/upload/id_upload" onChange={(paths) => formik.setFieldValue('id_upload', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="id_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcardpicture')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.idcardpicture)}>
                                                    <Uploader name="idcardpicture" showUploadedFiles value={formik.values.idcardpicture} uploadPath="fileuploader/upload/idcardpicture" onChange={(paths) => formik.setFieldValue('idcardpicture', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="idcardpicture" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('signUpload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.sign_upload)}>
                                                    <Uploader name="sign_upload" showUploadedFiles value={formik.values.sign_upload} uploadPath="fileuploader/upload/sign_upload" onChange={(paths) => formik.setFieldValue('sign_upload', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="sign_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('houseUpload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.house_upload)}>
                                                    <Uploader name="house_upload" showUploadedFiles value={formik.values.house_upload} uploadPath="fileuploader/upload/house_upload" onChange={(paths) => formik.setFieldValue('house_upload', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="house_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-3 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mapUpload')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.map_upload)}>
                                                    <Uploader name="map_upload" showUploadedFiles value={formik.values.map_upload} uploadPath="fileuploader/upload/map_upload" onChange={(paths) => formik.setFieldValue('map_upload', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="map_upload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
MembermasterAddPage.defaultProps = {
	primaryKey: 'memberid',
	pageName: 'membermaster',
	apiPath: 'membermaster/add',
	routeName: 'membermasteradd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default MembermasterAddPage;
